import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import EntrySelector from './EntrySelector';
import PageSelector from "@bloonde/cms/cms-pages/components/PageSelector";
import EntryFormColsSchema from "./EntryFormColsSchema";
import {ConfigurationsContext} from "@main/contexts/ConfigurationsContext";
import {ButtonGroup, ToggleButton} from "react-bootstrap";
import {Entry} from "@bloonde/cms/cms-entries/models/Entry";
import projectWidgets from "@main/projectWidgets";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    className?: string;
  }
  formFilterValues: any
}

interface Context {
  element: Entry;
  setElement: (element: any) => any;
  selectedLang: string;
  setSelectedLang: (lang: string) => any;
  backendFormErrors: any;
}

function EntryForm(props: Prop) {
  const { formRef, onSubmit, context, className } = props.formConfig;
  const formFilterValues = props.formFilterValues;

  const { element, setElement, backendFormErrors, selectedLang, setSelectedLang } =
    useContext<Context>(context);

  const { langs } = useContext(ConfigurationsContext);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const [finalUiSchema, setFinalUiSchema] = useState<UiSchema>({});

  let translations = {
    label: t('label'),
    blank: t('blank'),
    parent_id: t('parent_id'),
    type: t('type'),
    page_id: t('page_id'),
    url: t('url'),
    icon: t('icon'),
    hierarchy: t('hierarchy'),
  };

  let schema: any = {
    type: "object",
    properties: {
      label: {
        type: ['object', 'null'],
        title: '',
        properties: {},
      },
      type: {
        type: 'number',
        title: translations.type,
        default: 0,
      },
      hierarchy: {
        type: ['boolean', 'number'],
        title: translations.hierarchy,
        default: false,
      },
      page_id: {
        type: ['integer', 'null'],
        title: translations.page_id,
        show: element.type == 0,
      },
      url: {
        type: 'string',
        title: translations.url,
        show: element.type == 1,
      },
      // icon: {
      //   type: ['string', 'null'],
      //   title: translations.icon,
      // },
      blank: {
        type: 'boolean',
        title: translations.blank,
        show: false,
        default: 0,
      },
      parent_id: {
        type: ['integer', 'null'],
        title: translations.parent_id,
      },
    },
  };

  const uiSchema: UiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    type: {
      "ui:widget": "type-selector",
      "ui:options": {
        "configPath": "types.entries.type",
      }
    },
    page_id: {
      "ui:widget": "page-selector",
    },
    icon: {
      "ui:widget": "icon-selector",
    },
    parent_id: {
      "ui:widget": "entry-selector",
      "ui:options": {
        filters: formFilterValues
      }
    },
    colsSchema: EntryFormColsSchema,
    label: {
      colsSchema: []
    }
  };
  const customWidgets = {
    ...widgets,
    ...projectWidgets,
    ...{
      "entry-selector": EntrySelector,
      "page-selector": PageSelector
    },
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  const setSchemaLangFields = () => {
    let new_labels: any = {}
    for (let lang of langs) {
      new_labels[lang] = {
          type: 'string',
          title: t('label'),
      };
      if (selectedLang != lang) {
        uiSchema['label'][lang] = {"ui:widget": "hidden"};
      }
    }
    schema.properties.label.properties = new_labels;
    setFinalSchema(processSchemaFunction(schema, element));
    setFinalUiSchema(uiSchema);
  }

  useEffect(() => {
    setSchemaLangFields();
  }, [langs, element, selectedLang]);

  return (
  <>
    <div className="text-right mb-3">
      {
        <ButtonGroup>
          {langs.map((lang: string, index: number) => (
              <ToggleButton
                  key={index}
                  id={`entry-${index}`}
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  value={lang}
                  checked={selectedLang === lang}
                  onChange={(e) => setSelectedLang(e.currentTarget.value)}
              >
                {t(lang)}
              </ToggleButton>
          ))}
        </ButtonGroup>
      }
    </div>

    <JSONSchemaForm
        noHtml5Validate
        showErrorList={false}
        ref={formRef}
        schema={finalSchema}
        uiSchema={finalUiSchema}
        widgets={customWidgets}
        formData={element}
        validator={validator}
        onChange={handleChange}
        onSubmit={onSubmit}
        onError={log("errors")}
        extraErrors={backendFormErrors}
    />
  </>
  );
}

export default EntryForm;
